import {
  LineChart, CircuitBoard, LayoutGrid, ShieldCheck, Workflow, BarChart3,
  TrendingUp, Server, Boxes, Rocket, Cpu, MapPin, Lightbulb, Eye, Users,
  RefreshCw, Target, Linkedin, Twitter, Instagram, Youtube, Mail, Phone,
  ArrowRight, ArrowUpRight, Menu, X, Check, ExternalLink, Database, Code2,
  Cloud, Activity, Zap, Building2, Sparkles, GraduationCap, Layers,
} from "lucide-react";

export const ICONS = {
  LineChart, CircuitBoard, LayoutGrid, ShieldCheck, Workflow, BarChart3,
  TrendingUp, Server, Boxes, Rocket, Cpu, MapPin, Lightbulb, Eye, Users,
  RefreshCw, Target, Linkedin, Twitter, Instagram, Youtube, Mail, Phone,
  ArrowRight, ArrowUpRight, Menu, X, Check, ExternalLink, Database, Code2,
  Cloud, Activity, Zap, Building2, Sparkles, GraduationCap, Layers,
};

export function Icon({ name, ...props }) {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp {...props} />;
}
